const format = require('format-number')({
    integerSeparator: " ",
    decimalsSeparator: " ",
    decimal: ",",
});

if(!customElements.get("finance-annuity-required-income")) customElements.define("finance-annuity-required-income", class extends HTMLElement {
    static get observedAttributes() {
        return ['price', 'initialPayment','initialpayment', 'rate', 'term'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        switch (name.toLowerCase()) {
            case "price":
                this.updateText(
                    Number.parseFloat(newValue),
                    Number.parseFloat(this.getAttribute('initialPayment')),
                    Number.parseFloat(this.getAttribute('term')),
                    Number.parseFloat(this.getAttribute('rate')),
                );
                break;
            case "initialpayment":
                this.updateText(
                    Number.parseFloat(this.getAttribute('price')),
                    Number.parseFloat(newValue),
                    Number.parseFloat(this.getAttribute('term')),
                    Number.parseFloat(this.getAttribute('rate')),
                );
                break;
            case "term":
                this.updateText(
                    Number.parseFloat(this.getAttribute('price')),
                    Number.parseFloat(this.getAttribute('initialPayment')),
                    Number.parseFloat(newValue),
                    Number.parseFloat(this.getAttribute('rate')),
                );
                break;
            case "rate":
                this.updateText(
                    Number.parseFloat(this.getAttribute('price')),
                    Number.parseFloat(this.getAttribute('initialPayment')),
                    Number.parseFloat(this.getAttribute('term')),
                    Number.parseFloat(newValue),
                );
                break;
        }
    }

    connectedCallback() {
        this.updateText(
            Number.parseFloat(this.getAttribute('price')),
            Number.parseFloat(this.getAttribute('initialPayment')),
            Number.parseFloat(this.getAttribute('term')),
            Number.parseFloat(this.getAttribute('rate')),
        );
    }

    updateText(price, initialPayment, term, rate) {
        if (
            typeof price !== 'undefined' && !Number.isNaN(price) && Number.isFinite(price) &&
            typeof initialPayment !== 'undefined' && !Number.isNaN(initialPayment) && Number.isFinite(initialPayment) &&
            typeof term !== 'undefined' && !Number.isNaN(term) && Number.isFinite(term) &&
            typeof rate !== 'undefined' && !Number.isNaN(rate) && Number.isFinite(rate)
        ) {
            const paymentFn = window.cian_calculator_find_payment || function () {
                const i = rate / 12 / 100;
                const pow = Math.pow(i + 1, term * 12);
                const K = i * pow / (pow - 1);
                let payment = Math.round((price - initialPayment) * K);
                if (payment < 0) {
                    payment = 0;
                }
                return payment;
            };
            console.log(paymentFn);
            const payment = paymentFn(price, initialPayment, term, rate);
            const incomeFn = window.cian_calculator_find_required_income || function() {
                return payment / 0.6;  
            };
            const income = Math.round(incomeFn(payment, price, initialPayment, term, rate));

            this.innerHTML = format(income) + (this.hasAttribute('suffix') ? this.getAttribute('suffix') : " ₽");
        }
    }
});
